import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import MotorCreditoFormulaList from './MotorCreditoFormulaList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import MotorCreditoFormulaCadastrar from './MotorCreditoFormulaCadastrar';
import { Messages } from 'primereact/messages';
import postMotorCreditoFormula from '../../service/postMotorCreditoFormula';
import putMotorCreditoFormula from '../../service/putMotorCreditoFormula';

export default function MotorCreditoFormulaPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [motorCreditoFormula, setMotorCreditoFormula] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveMotorCreditoFormula = (motorCreditoFormula:any) => {
    if(motorCreditoFormula.id){
      putMotorCreditoFormula(motorCreditoFormula).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setMotorCreditoFormula(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    else{
      postMotorCreditoFormula(motorCreditoFormula).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setMotorCreditoFormula(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setMotorCreditoFormula({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-sliders-h" style={{ fontSize: '2.0rem' }}></i> {t('formulaCredito')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!motorCreditoFormula && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <MotorCreditoFormulaList onEdit={(motorCreditoFormula:any) => { setMotorCreditoFormula(motorCreditoFormula);}}></MotorCreditoFormulaList>
          </>
        )}
        {motorCreditoFormula && (
          <>
           <MotorCreditoFormulaCadastrar motorCreditoFormula={motorCreditoFormula} onSave={saveMotorCreditoFormula} onClose={() => {setMotorCreditoFormula(null)}}></MotorCreditoFormulaCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
